import React from 'react';
import PropTypes from 'prop-types';

const SignUpContent = ({ title, hasRightCard, children, isInLoggedInEditProfileMode }) => (
  <div className="SignUpContent">
    {
      !isInLoggedInEditProfileMode &&
      <h2
        className="mb-0"
        aria-label={title}
      >
        {title}
      </h2>
    }
    <div className="content-box">
      {
        isInLoggedInEditProfileMode &&
        <h1
          className="mb-0 col-12 pl-2"
          aria-label={title}
        >
          {title}
        </h1>
      }
      {children}
    </div>
  </div>
);

SignUpContent.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  hasRightCard: PropTypes.bool,
  isInLoggedInEditProfileMode: PropTypes.bool
};

SignUpContent.defaultProps = {
  title: null,
  children: null,
  hasRightCard: true,
  isInLoggedInEditProfileMode: false
};

export default SignUpContent;
